export default __webpack_public_path__ + "static/ThinkstockPhotos-123052600_article-1cb0327633f667448ed55065e0cc1399.jpg";